<template>
  <section class="sction homescreen" :style="color">
    <div class="homeprofile">
      <div class="homeheader columns is-mobile">
        <div class="column is-3">
          <a @click="$router.push('/profile')">
            <div
              v-bind:style="{ 'background-image': image }"
              v-if="profile.picture === ''"
              class="homeprofileimg"
            ></div>
            <div :style="profile.picture" v-else class="homeprofileimg"></div>
          </a>
        </div>
        <div class="column is-7">
          <h6 class="home title" :style="textColor">
            Hi
            <span>
              <span
                v-if="profile.fname === ''"
                class="preload"
                style="width: 100px"
              ></span>
              <span v-else>{{ profile.fname }}</span>
            </span>
            <img src="../assets/img/hi.png" width="28px" />
          </h6>
        </div>
        <div class="column is-2">
          <a @click="$router.push('/search')" class="searchIcon">
            <i class="fas fa-search"></i>
          </a>
        </div>
      </div>
      <div v-if="delivered" class="columns">
        <div class="column has-text-centered">
          <h1 class="title is-5 yourtasks">You Have 5 Tasks</h1>
        </div>
      </div>
      <div v-if="delivered" class="columns">
        <div class="column">
          <flickity ref="flickity" :options="flickityOptions">
            <!-- project -->
            <div class="cardholder">
              <div class="card">
                <div class="videocontainer">
                  <video-player
                    v-if="vid1.loaded"
                    class="vjs-custom-skin uploadVid"
                    ref="videoPlayer1"
                    :options="vid1"
                    :playsinline="true"
                    v-observe-visibility="
                      (isVisible, entry) =>
                        visibilityChanged(isVisible, entry, $refs.videoPlayer1)
                    "
                  ></video-player>
                </div>
                <div class="cardtype">
                  <span>
                    Robotics: <b>{{ project.name }}</b>
                  </span>
                </div>
                <!-- <img :src="project.featuredImg" alt="Placeholder image" /> -->
                <div class="card-content">
                  <div class="content">
                    {{ project.description }}
                  </div>
                </div>
                <div class="cardbtns">
                  <button
                    class="btn btn-theme"
                    @click="$router.push('/project/' + project.id + '/2')"
                  >
                    Start
                  </button>
                  <a
                    class="link"
                    @click="setreminder(project.name, project.description)"
                  >
                    <i class="fas fa-bell"></i>
                    <span>Set a reminder</span>
                  </a>
                </div>
                <div class="pagination">
                  <span>1 / 5</span>
                </div>
              </div>
            </div>
            <!-- /project -->
            <!-- origami -->
            <div class="cardholder">
              <div
                class="card"
                v-observe-visibility="
                  (isVisible, entry) =>
                    visibilityChanged(isVisible, entry, $refs.videoPlayer2)
                "
              >
                <video-player
                  v-if="vid2.loaded"
                  class="vjs-custom-skin uploadVid"
                  ref="videoPlayer2"
                  :options="vid2"
                  :playsinline="true"
                ></video-player>
                <div class="cardtype">
                  <span>
                    Origami: <b>{{ origami.name }}</b>
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    {{ origami.description }}
                  </div>
                </div>
                <div class="cardbtns">
                  <button
                    class="btn btn-theme"
                    @click="$router.push('/project/' + origami.id + '/2')"
                  >
                    Start
                  </button>
                  <a
                    class="link"
                    @click="setreminder(origami.name, origami.description)"
                  >
                    <i class="fas fa-bell"></i>
                    <span>Set a reminder</span>
                  </a>
                </div>
                <div class="pagination">
                  <span>2 / 5</span>
                </div>
              </div>
            </div>
            <!-- /origami -->
            <!-- challenge -->
            <div class="cardholder">
              <div class="card">
                <img :src="challenge.featuredImg" alt="" />
                <div class="cardtype">
                  <span>
                    <b>{{ challenge.name }}</b>
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    {{ challenge.description }}
                  </div>
                </div>
                <div class="cardbtns">
                  <button
                    class="btn btn-theme"
                    @click="$router.push('/challenge/' + challenge.id)"
                  >
                    Start
                  </button>
                  <a
                    class="link"
                    @click="setreminder(challenge.name, challenge.description)"
                  >
                    <i class="fas fa-bell"></i>
                    <span>Set a reminder</span>
                  </a>
                </div>
                <div class="pagination">
                  <span>3 / 5</span>
                </div>
              </div>
            </div>
            <!-- /challenge -->
            <!-- votw -->
            <div class="cardholder">
              <div
                class="card"
                v-observe-visibility="
                  (isVisible, entry) =>
                    visibilityChanged(isVisible, entry, $refs.videoPlayer3)
                "
              >
                <video-player
                  v-if="vid3.loaded"
                  class="vjs-custom-skin uploadVid"
                  ref="videoPlayer3"
                  :options="vid3"
                  :playsinline="true"
                ></video-player>
                <div class="cardtype">
                  <span> Take This Quiz </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    {{ votw.desc }}
                  </div>
                  <!-- <div class="content">
                    <h3 class="subtitle is-5">
                      {{ votw.text }}
                    </h3>
                    <div v-if="!quizanswered">
                      <div class="columns is-mobile">
                        <div class="column">
                          <a
                            class="button is-small is-fullwidth"
                            @click="useranswer = votw.options[0]"
                            :class="{
                              'is-right': votw.answer == votw.options[0],
                              'is-wrong': votw.answer != votw.options[0],
                              'is-selected': useranswer == votw.options[0],
                            }"
                          >
                            {{ votw.options[0] }}
                          </a>
                        </div>
                        <div class="column">
                          <a
                            class="button is-small is-fullwidth"
                            @click="useranswer = votw.options[1]"
                            :class="{
                              'is-right': votw.answer == votw.options[1],
                              'is-wrong': votw.answer != votw.options[1],
                              'is-selected': useranswer == votw.options[1],
                            }"
                          >
                            {{ votw.options[1] }}
                          </a>
                        </div>
                      </div>
                      <div class="columns is-mobile">
                        <div class="column">
                          <a
                            class="button is-small is-fullwidth"
                            @click="useranswer = votw.options[2]"
                            :class="{
                              'is-right': votw.answer == votw.options[2],
                              'is-wrong': votw.answer != votw.options[2],
                              'is-selected': useranswer == votw.options[2],
                            }"
                          >
                            {{ votw.options[2] }}
                          </a>
                        </div>
                        <div class="column">
                          <a
                            class="button is-small is-fullwidth"
                            @click="useranswer = votw.options[3]"
                            :class="{
                              'is-right': votw.answer == votw.options[3],
                              'is-wrong': votw.answer != votw.options[3],
                              'is-selected': useranswer == votw.options[3],
                            }"
                          >
                            {{ votw.options[3] }}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p v-if="useranswer == votw.answer">
                        Congratulations, you got it right!
                      </p>
                      <p v-else>You are wrong!</p>
                    </div>
                  </div> -->
                </div>
                <div class="cardbtns">
                  <button
                    class="btn btn-theme"
                    @click="$router.push('/quiz/' + votw.quiz)"
                  >
                    Start
                  </button>
                </div>
                <div class="pagination">
                  <span>4 / 5</span>
                </div>
              </div>
            </div>
            <!-- /votw -->
            <!-- session -->
            <div class="cardholder">
              <div class="card">
                <img :src="session.image" alt="Live Session" />
                <div class="cardtype has-text-centered">
                  <span>
                    Live Workshop on {{ new Date(session.date).getDate() }}
                    {{ month[new Date(session.date).getMonth()] }}
                  </span>
                </div>
                <div class="card-content">
                  <div class="content">
                    {{ session.description }}
                  </div>
                </div>
                <div class="cardbtns">
                  <button
                    class="btn btn-theme"
                    :disabled="new Date().getTime > session.date"
                  >
                    Attend
                  </button>
                  <a
                    class="link"
                    :href="session.participantLink"
                    target="blank"
                    v-if="new Date().getTime < session.date"
                  >
                    <i class="fas fa-bell"></i>
                    <span>Join as Participant</span>
                  </a>
                </div>
                <div class="pagination">
                  <span>5 / 5</span>
                </div>
              </div>
            </div>
            <!-- /session -->
          </flickity>
        </div>
      </div>
      <div v-if="!delivered" class="columns">
        <div class="column">
          <div
            v-if="stage == 0"
            class="card"
            style="min-height: auto !important"
          >
            <div class="card-content">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/subscription%2Fa1_delivery%2Fprocessing.gif?alt=media&token=226062ff-b53e-4a38-af5a-31a8584cacb0"
                alt=""
              />
              <article class="message is-link">
                <div class="message-body">
                  <p>Your order is being processed.</p>
                </div>
              </article>
            </div>
          </div>
          <div
            v-if="stage == 1"
            class="card"
            style="min-height: auto !important"
          >
            <div class="card-content">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/subscription%2Fa1_delivery%2Fin-transit.gif?alt=media&token=3c5d38c1-c90d-4299-85e1-1fbb6314df48"
                alt=""
              />
              <article class="message is-link">
                <div class="message-body">
                  <p>We have shipped your order.</p>
                </div>
              </article>
            </div>
          </div>
          <div
            v-if="stage == 2"
            class="card"
            style="min-height: auto !important"
          >
            <div class="card-content">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/subscription%2Fa1_delivery%2Fprocessing.gif?alt=media&token=226062ff-b53e-4a38-af5a-31a8584cacb0"
                alt=""
              />
              <article class="message is-link">
                <div class="message-body">
                  <p>Your order is out for delivery.</p>
                </div>
              </article>
            </div>
          </div>
          <div
            v-if="stage == 3"
            class="card"
            style="min-height: auto !important"
          >
            <div class="card-content">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/subscription%2Fa1_delivery%2Fdelivered.gif?alt=media&token=fc3447cc-e333-4a8c-93c3-e364a3ec4baa"
                alt=""
              />
              <article class="message is-link">
                <div class="message-body">
                  <p>Your order has been delivered.</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="columns">
        <div class="column">
          <div class="card">
            <div class="card-content">
              <div class="columns">
                <div class="column">
                  <h6 class="subtitle" style="margin-bottom: 10px">
                    Your next tasks:
                  </h6>
                  <ul style="padding-bottom: 20px">
                    <li>Project</li>
                    <li>Origami</li>
                    <li>Challenge</li>
                    <li>Live Session</li>
                    <li>Video of the Week</li>
                  </ul>
                  <a
                    class="button is-fullwidth"
                    @click="$router.push('/task/1')"
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="columns">
        <div class="column">
          <div class="timer">
            <div class="columns is-mobile">
              <div class="column is-2 has-text-centered">
                <div class="timer-icon" style="font-size: 1.8rem">
                  <i class="fas fa-clock"></i>
                </div>
              </div>
              <div class="column">
                Your have {{ countdown }} time remaining to complete these
                tasks.
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="columns">
        <div class="column">
          <div class="buttons" style="justify-content: center">
            <a class="button" @click="$router.push('/subscription_orders')">
              Manage Subscription
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// import VLazyImage from "v-lazy-image";
import { mapGetters } from "vuex";
import { db } from "@/main.js";
import { auth } from "@/main.js";
// import { functions } from "@/main.js";
import "@/assets/css/video-js.css";
import { videoPlayer } from "vue-video-player";
import Flickity from "vue-flickity";
import * as Add2Calendar from "add2calendar";
export default {
  name: "subscribed",
  mounted() {
    console.log(auth.currentUser.uid);
    this.vid.loaded = true;
  },
  components: {
    videoPlayer,
    Flickity,
  },
  data() {
    return {
      user: {},
      image: "url(" + require("@/assets/img/user.png") + ")",
      color: "",
      textColor: "",
      delivered: false,
      stage: 0,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        autoPlay: false,
        // any options from Flickity can be used
      },
      project: {},
      origami: {},
      challenge: {},
      votw: {},
      useranswer: "",
      quizanswered: false,
      live: {},
      session: {},
      week: "",
      vid1: {
        height: "100%",
        width: "100%",
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: "",
        loaded: false,
      },
      vid2: {
        height: "100%",
        width: "100%",
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: "",
        loaded: false,
      },
      vid3: {
        height: "100%",
        width: "100%",
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: "",
        loaded: false,
      },
      month: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      countdown: "7d 23h 59m 59s",
    };
  },
  beforeMount() {
    this.getColor();
    db.collection("users")
      .doc(auth.currentUser.uid)
      .get()
      .then((user) => {
        this.user = user.data();
        this.user.id = user.id;
        if (!user.data().premium) this.$router.push("/subscription");
      });
    db.collection("subscriptionorders")
      .where("uid", "==", auth.currentUser.uid)
      .orderBy("due", "desc")
      .limit(1)
      .get()
      .then((order) => {
        console.log("order data:", order.docs[0].id, order.docs[0].data());
        if (order.docs[0].data().delivered) this.delivered = true;
        if (order.docs[0].data().stage) this.stage = order.docs[0].data().stage;
        db.collection("subscriptionbox")
          .doc(order.docs[0].data().boxId)
          .get()
          .then((box) => {
            console.log("box data:", box.id, box.data());
            //fetch project
            db.collection("projects")
              .doc(box.data().projects[0])
              .get()
              .then((project) => {
                this.project = project.data();
                this.project.id = project.id;
                this.vid1.poster = project.data().featuredImg;
                this.vid1.sources = [
                  {
                    src: project.data().trailer,
                    type: "video/mp4",
                  },
                ];
                setTimeout(() => {
                  this.vid1.loaded = true;
                }, 100);
              });
            //fetch week
            var dispatchDate = order.docs[0].data().dispatchDate;
            db.collection("subscriptionweek")
              .where("start", ">", dispatchDate)
              .orderBy("start", "asc")
              .limit(1)
              .get()
              .then((week) => {
                this.week = week.docs[0].id;
                console.log("week data:", week.docs[0].id, week.docs[0].data());
                //live session
                this.session = week.docs[0].data().session;
                //votw
                this.votw = week.docs[0].data().votw;
                this.useranswer = "";
                db.collection("subscriptionweek")
                  .doc(this.week)
                  .collection("quiz")
                  .doc(auth.currentUser.uid)
                  .get()
                  .then((quiz) => {
                    if (quiz.exists) {
                      this.quizanswered = true;
                      this.useranswer = quiz.data().answer;
                    }
                  });
                this.vid3.sources = [
                  {
                    src: week.docs[0].data().votw.video,
                    type: "video/mp4",
                  },
                ];
                setTimeout(() => {
                  this.vid3.loaded = true;
                }, 100);
                //fetch origami
                console.log(week.docs[0].data().origami[0]);
                db.collection("projects")
                  .doc(week.docs[0].data().origami[0])
                  .get()
                  .then((project) => {
                    this.origami = project.data();
                    this.origami.id = project.id;
                    this.vid2.poster = project.data().featuredImg;
                    this.vid2.sources = [
                      {
                        src: project.data().trailer,
                        type: "video/mp4",
                      },
                    ];
                    setTimeout(() => {
                      this.vid2.loaded = true;
                    }, 100);
                  });
                //fetch challenge
                db.collection("challenges")
                  .doc(week.docs[0].data().challenge.id)
                  .get()
                  .then((challenge) => {
                    this.challenge = challenge.data();
                    this.challenge.id = challenge.id;
                  });
              });
          });
      });
    var countDownDate = 1658227451000;
    setInterval(() => {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.countdown =
        days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
    }, 1000);
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  methods: {
    visibilityChanged(isVisible, entry, videoPlayer) {
      if (isVisible) videoPlayer.player.play();
      else videoPlayer.player.pause();
    },
    getColor() {
      this.$store.commit("getColorInfo");
      this.color =
        "background: linear-gradient(360deg, #ffffff 0%, #ffffff 65%, " +
        this.$store.state.selectedColor.c1 +
        " 100%);";
      this.textColor = "color: " + this.$store.state.selectedColor.c2 + ";";
    },
    submitQuiz() {
      this.quizanswered = true;
      db.collection("subscriptionweek")
        .doc(this.week)
        .collection("quiz")
        .doc(auth.currentUser.uid)
        .set({
          answer: this.useranswer,
          user: auth.currentUser.uid,
          timestamp: Date.now(),
        });
    },
    setreminder(title, desc) {
      var date = new Date();
      date.setDate(date.getDate() + 1);
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = months[date.getMonth()];
      console.log(
        month + " " + date.getDate() + ", " + date.getFullYear() + " 10:30"
      );
      var singleEventArgs = {
        title: title,
        start:
          month + " " + date.getDate() + ", " + date.getFullYear() + " 10:30",
        end:
          month + " " + date.getDate() + ", " + date.getFullYear() + " 10:30",
        location: "https://app.witblox.com/subscribed",
        description: desc,
        isAllDay: true,
      };
      var singleEvent = new Add2Calendar(singleEventArgs);
      window.open(singleEvent.getGoogleUrl(), "_blank");
      //   console.log(singleEvent.getICalUrl());
    },
  },
};
</script>
<style scoped>
.sction {
  padding-bottom: 80px;
}
.box {
  border-radius: 20px;
}
ul {
  list-style-type: circle;
  padding-left: 30px;
  font-size: 1rem;
  font-weight: 600;
}
.buttons a.button {
  border: 4px solid #000;
  background: #0000;
  color: #000;
  font-size: 1rem;
  font-weight: 800;
}
.card {
  border-radius: 15px;
}
/* */
.card {
  border-radius: 0 0 14px 14px;
  box-shadow: none;
  border: 2px solid;
  min-height: 550px;
}
.cardholder {
  width: 100%;
  min-height: 70vh;
  padding: 0 5px;
}

.btn {
  margin-bottom: 10px;
}

a.link {
  text-align: center;
  display: block;
  font-size: 0.8rem;
}
a.link i {
  padding-right: 5px;
}
a.link span {
  border-bottom: 2px solid;
  display: inline-block;
}
.videosection,
.video-container,
.video-player,
.vjs_video_3-dimensions,
.video-js {
  width: 100%;
  height: 200px !important;
}
.flickity-viewport {
  overflow: inherit !important;
}
.card .cardbtns {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
}
.pagination {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: right;
  padding: 20px;
  display: block;
}
.pagination span {
  background: #fff;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 800;
}
a.button.is-selected {
  background: #5a3e90;
  color: #fff;
}

.yourtasks {
  display: inline;
  background: #fff;
  padding: 5px 15px;
  border: none !important;
  border-radius: 10px;
}

.is-selected.is-right {
  background: green !important;
  border: green;
}

.is-selected.is-wrong {
  background: red !important;
  border: red;
}
</style>
<style>
.videosection,
.video-container,
.video-player,
.vjs_video_3-dimensions,
.video-js {
  width: 100%;
  height: 300px;
}
.scta {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 50px 60px 50px;
}
.grid-bg {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  text-size-adjust: 100%;
  color: #4a4a4a;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
  font-family: Poppins, sans-serif;
  box-sizing: inherit;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4"%3E%3Cpath fill="%239C92AC" fill-opacity="0.4" d="M1 3h1v1H1V3zm2-2h1v1H3V1z"%3E%3C/path%3E%3C/svg%3E');
}

@media only screen and (max-width: 992px) {
  .project .container {
    width: 95%;
  }
}

.project .container {
  width: 80%;
}

.project .card {
  border-radius: 12px;
  display: block;
}
.c1 {
  /* transform: rotate(4deg); */
  background-color: rgb(56, 161, 78);
}
.c2 {
  /* transform: rotate(-2deg); */
  background-color: rgb(189, 17, 78);
}
@media only screen and (max-width: 450px) {
  .project .title,
  .reviews .card .title {
    font-size: 1.25rem;
  }
}
.project .title,
.reviews .card .title {
  font-size: 1rem;
}
.grid-bg .title {
  padding-bottom: 25px;
}
.project .title {
  color: rgb(255, 255, 255);
}
.c3 {
  /* transform: rotate(2deg); */
  background-color: rgb(237, 127, 30);
}
.c4 {
  /* transform: rotate(4deg); */
  background-color: rgb(114, 51, 137);
}
.reviews .card {
  border-radius: 10px;
}
.r1 {
  background: rgb(189, 17, 78);
  /* transform: rotate(3deg); */
}
.r2 {
  background: rgb(237, 127, 30);
  /* transform: rotate(-2deg); */
}
.r3 {
  background: rgb(114, 51, 137);
  /* transform: rotate(2deg); */
}
.reviews .card img {
  width: 45px;
  margin-right: 5px;
  border-radius: 50%;
}

.project .title,
.reviews .card .title {
  font-size: 1rem;
}

.reviews .card .title {
  color: rgb(255, 255, 255);
}

.reviews .card p {
  color: rgb(255, 255, 255);
}
.cardtype {
  background: #5a3e90;
  padding: 7px 25px;
  color: #fff;
}
.cardtype span {
  font-weight: 600;
}

.timer {
  background: #5a3e90;
  color: #fff;
  font-size: 0.8rem;
  padding: 20px;
  font-weight: 500;
}
</style>